var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("vs-input", {
    directives: [
      {
        name: "validate",
        rawName: "v-validate",
        value: _vm.validation,
        expression: "validation"
      }
    ],
    class: _vm.clases,
    attrs: {
      id: _vm.id,
      label: _vm.label,
      "data-cy": _vm.name || "input-" + _vm.id,
      placeholder: _vm.placegolder,
      state: _vm.state,
      "data-vv-as": _vm.dataAs,
      disabled: _vm.disabled,
      danger: _vm.danger,
      "danger-text": _vm.dangerText
    },
    on: {
      blur: function($event) {
        return _vm.onFocus(false)
      },
      focus: function($event) {
        return _vm.onFocus(true)
      }
    },
    model: {
      value: _vm.displayValue,
      callback: function($$v) {
        _vm.displayValue = $$v
      },
      expression: "displayValue"
    }
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }